import React from 'react'
import { useIntl } from 'react-intl'
import { DateTime } from 'luxon'
import logo from '../../assets/imgs/logos/logoMoureBlue.svg'
import './cardNews.scss'

const CardNews = ({ post }) => {
  const intl = useIntl()

  const formatDateToString = (date) => {
    const dt = DateTime.fromISO(date)
    return dt.setLocale('es-Es').toLocaleString(DateTime.DATETIME_MED)
  }

  return (
    <article className="article">
      <div className="article-imgBox">
        {post.og_image?.[0]?.url ? (
          <img className="img" alt="" src={post.og_image?.[0]?.url} />
        ) : (
          <img className="img" alt="" src={logo} />
        )}
      </div>
      <h3 className="title__subtitle">
        <a href={post.og_url}>{post.title}</a>
      </h3>
      <p className="text__with-color">
        <span>{formatDateToString(post.article_published_time)}</span>
      </p>
      <p className="text__container">{post.og_description}</p>
      <a className="text__with-color" href={post.og_url}>
        {intl.formatMessage({ id: 'news.moreInfo' })}
      </a>
    </article>
  )
}

export default CardNews
